import ItemComboSalesDetails from '../../ItemComboSales/ItemComboSalesDetails';

const SalesOverviewDetails = () => {
  return <ItemComboSalesDetails bucket="salesOverviewReports" />;
};

export default SalesOverviewDetails;
